import { ActivityCreateActivityPopUpModule } from './../activity/activity-create-activity-pop-up/activity-create-activity-pop-up.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ActivityListRoutingModule } from './activity-list-routing.module';
import { ActivityListComponent } from './activity-list.component';
import { DxButtonModule, DxChartModule, DxDataGridModule, DxDropDownButtonModule, DxPopupModule, DxRangeSelectorModule, DxTextAreaModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { InfoHeaderModule } from 'src/app/widgets/info-header/info-header.module';
import { InfoTableModule } from 'src/app/widgets/info-table/info-table.component';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';


@NgModule({
  declarations: [ActivityListComponent],
  imports: [
    CommonModule,
		ActivityListRoutingModule,
		DxTableControllerDirective,
		DxChartModule,
		DxDropDownButtonModule,
		DxTextAreaModule,
		DxRangeSelectorModule,
		DxDataGridModule,
		DevEpressCommonModule,
		DxButtonModule,
		DxPopupModule,
		InfoHeaderModule,
		InfoTableModule,
		ActivityCreateActivityPopUpModule,
		BookmarkModule,

		BookmarkNewComponent,
		FiltersGroupModule,
		HelpButtonComponent,
		ContainerComponent,
  ]
})
export class ActivityListModule { }
